<template>
  <div>
    <b-card header="Opciones de Filtro" class="card-filter">
      <b-btn class="filter-collapse" 
          variant="primary" 
          size="sm"
          @click.prevent="showOpcionesFiltro= !showOpcionesFiltro">
        <i :class="showOpcionesFiltro ? 'fa fa-caret-up' : 'fa fa-caret-down'"></i>
      </b-btn>
      <b-collapse id="filtro" class="mt-2" v-model="showOpcionesFiltro">
        <b-form>
          <b-form-group
            label="Desde"
            label-for="fechaDesde"
            :label-cols="2"
            horizontal>
            <b-form-input 
              id="fechaDesde" 
              v-model= "filtro.fechaDesde" 
              type="date">
            </b-form-input>
          </b-form-group>

          <b-form-group
            label="Hasta"
            label-for="fechaHasta"
            :label-cols="2"
            horizontal>
            <b-form-input 
              id="fechaHasta" 
              v-model= "filtro.fechaHasta" 
              type="date">
            </b-form-input>
          </b-form-group>

          <b-form-group
            label="Impuesto"
            label-for="impuesto"
            :label-cols="2"
            horizontal>
            <b-input-group>
              <b-input-group-append 
                  class="filter-search-icons" 
                  @click="seleccionarImpuesto">
                <b-input-group-text>
                  <i :class="{ 'fa fa-search': !filtro.impuesto,
                                'fa fa-remove': filtro.impuesto  }"></i>
                </b-input-group-text>
              </b-input-group-append>
              <b-form-input 
                id="impuesto"
                :value="impuestoNombre"
                readonly
                type="text"/>
            </b-input-group>
          </b-form-group>

          <!-- <b-form-group
            :label-cols= '2'
            horizontal>
            <b-form-checkbox 
                id="sortByDescending"
                v-model="filtro.sortByDescending"
                :value= "Boolean(true)"
                :unchecked-value= "Boolean(false)">
                Ordenar comprobantes en forma descendente
            </b-form-checkbox>
          </b-form-group> -->
        </b-form>

        <div class="footer">
          <b-button size="sm" variant="primary" class="footer-button"
            @click.prevent="filtrar">Filtrar</b-button>
          <b-button size="sm" variant="primary" class="footer-button" 
            @click.prevent="limpiarFiltro">Limpiar</b-button>
        </div>
      </b-collapse>
    </b-card>

    <b-modal ref="searchImpuestoModal" 
        title="Seleccionar Impuesto"
        header-bg-variant= "light" 
        hide-footer
        lazy
        modal-class="proveedores-search-modal">
      <app-search-impuesto
        @impuestoSeleccionado="impuestoSeleccionado">
      </app-search-impuesto>  
    </b-modal>
  </div>
</template>

<script>
import SearchImpuesto from '../impuestos/SearchList.vue'
import moment from 'moment';

export default {
  components: {
    appSearchImpuesto: SearchImpuesto,
  },
  props: {
    fechaDesde: {
      type: Date,
      /*default: ''*/
    },
    fechaHasta: {
      type: Date,
      /*default: ''*/
    },
    impuesto: {
      type: Object,
      default: null
    },
    sortByDescending: {
      type: Boolean,
      default: false,
    }
  },
  data() {
    return {
      filtro: {
        fechaDesde: '',
        fechaHasta: '',
        impuesto: null,
        sortByDescending: false
      },
      showOpcionesFiltro: Boolean(false)
    }
  },
  created() {
      this.filtro.fechaDesde = moment.utc(this.fechaDesde).format('YYYY-MM-DD');
      this.filtro.fechaHasta = moment.utc(this.fechaHasta).format('YYYY-MM-DD');
      this.filtro.impuesto = this.impuesto;
      this.filtro.sortByDescending = this.sortByDescending;
  },
  computed: {
    'impuestoNombre': function() {
      return this.filtro.impuesto? this.filtro.impuesto.nombre.trim() : '';
    },
  },     
  methods: {
    filtrar() {
      this.$emit('filtrar', this.filtro);
    },
    limpiarFiltro() {
      this.filtro.impuesto = null;
      this.filtro.numeroCertificado = 0; 
    },
    seleccionarImpuesto() {
      if (this.filtro.impuesto) {
        this.filtro.impuesto = null;
      } else {
        this.$refs.searchImpuestoModal.show();
      }
    },
    impuestoSeleccionado(impuesto) {
      this.filtro.impuesto = impuesto;
      this.$refs.searchImpuestoModal.hide();
    },
  },
}
</script>

<style>
</style>
